import { combineEpics } from 'redux-observable';
import noteEpic from './noteEpic';

export default combineEpics(noteEpic);
